import BaseRequest from '../_baseRequest';

const baseUrl = 'Report/ReportByUrl';

const StoricoService = {
  comune: (Pattern, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_comuni_lov_diffusione?com=${Pattern}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  comuneCodice: (Codice, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_comuni_lov_diffusione?procom=${Codice}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  comuneRiepilogo: (Codice, Comune) => {
    const req = new BaseRequest();
    return req.makeRequest(
      {},
      { url: `var_get_ua_comuni_lov_rs?procom=${Codice}&com=${Comune}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  provinceUtsCodice: (Codice, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_uts_lov_diffusione?coduts=${Codice}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  provinceUts: (Pattern, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_uts_lov_diffusione?uts=${Pattern}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  provinceUtsRiepilogo: (Codice, Uts, tipo) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_uts_lov_rs?&uts=${Uts}&coduts=${Codice}&uts_tipo=${tipo}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  regione: (Pattern, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_reg_lov_diffusione?reg=${Pattern}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  regioneCodice: (Codice, cancelToken) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_reg_lov_diffusione?codreg=${Codice}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`,
      cancelToken
    );
  },

  regioneRiepilogo: (Codice, Reg, tipoReg) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      { url: `var_get_ua_reg_lov_rs?&codreg=${Codice}&reg=${Reg}&reg_tipo=${tipoReg}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  dettVariazioni: (idProvv, tipoVar, idComOrigine) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {
        url: `var_get_ua_comuni_lov_rs_dett?idcomuneorig=${idComOrigine}&mcrvar=${tipoVar}&idprovv=${idProvv}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  datiAssVariazioni: (idProvv, tipoVar, idComOrigine) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {
        url: `var_get_ua_comuni_lov_rs_dett_ass?idcomuneorig=${idComOrigine}&mcrvar=${tipoVar}&idprovv=${idProvv}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  dettVariazioniUts: (tipoVar, idProvv, id_uts, tipoUts) => {
    const req = new BaseRequest();
    return req.makeRequest(
      {},
      {
        url: `var_get_ua_uts_lov_rs_dett?&id_uts_origine=${id_uts}&idprovv=${idProvv}&uts_tipo=${tipoUts}&mcrvar=${tipoVar}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  datiAssVariazioniUts: (tipoVar, idProvv, id_uts, tipoUts) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {
        url: `var_get_ua_uts_lov_rs_dett_ass?&id_uts_origine=${id_uts}&idprovv=${idProvv}&uts_tipo=${tipoUts}&mcrvar=${tipoVar}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  dettVariazioniRegione: (tipoVar, tipoReg, idProvv, codiceReg) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {
        url: `var_get_ua_reg_lov_rs_dett?&reg_tipo=${tipoReg}&idprovv=${idProvv}&mcrvar=${tipoVar}&id_regione_origine=${codiceReg}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  },

  datiAssVariazioniReg: (tipoVar, tipoReg, idProvv, codiceReg) => {
    const req = new BaseRequest();

    return req.makeRequest(
      {},
      {
        url: `var_get_ua_reg_lov_rs_dett_ass?&reg_tipo=${tipoReg}&idprovv=${idProvv}&mcrvar=${tipoVar}&id_regione_origine=${codiceReg}`
      },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      `AZURE`
    );
  }
};

export default StoricoService;
